import React from 'react';
import { useAccess, useParams } from '@umijs/max';
import Exception403 from '@/pages/exception/403';
import { getAppName } from '@/utils/app-cache';

interface RoutePermissionGuardProps {
  permission: string;
  children: React.ReactNode;
}

const RoutePermissionGuard: React.FC<RoutePermissionGuardProps> = ({
  permission,
  children,
}) => {
  const access = useAccess();
  const hasPermission = access.hasPerm ? access.hasPerm(permission) : true;

  // 特例放行：个人知识库(appName==='users')允许所有用户查看，
  // 绕过知识库详情路由(dataset/:pageType/*)的 dataset:file:query 权限。
  // 详情 URL 形如 /data/dataset/dataset/<thirdpartyAppId>，thirdpartyAppId 落在通配 * 上，
  // 取其首段后通过 app 缓存还原知识库名称判定。
  const params = useParams();
  const thirdpartyAppId = (params['*'] || '').split('/')[0];
  const isPersonalKnowledge =
    !!thirdpartyAppId && getAppName(thirdpartyAppId) === 'users';

  if (!hasPermission && !isPersonalKnowledge) {
    return <Exception403 />;
  }

  return <>{children}</>;
};

export default RoutePermissionGuard;
